import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'


export async function cancelWagerStandard(wagerBytes32Id) {
    console.log("cancelling bet " + wagerBytes32Id);
    return ContractStore.exec("CancelController", "cancelWagerStandard", [
        wagerBytes32Id, true
    ], {
            from: Web3Store.account
        });
}

export async function cancelCustomWager(wagerBytes32Id) {
    console.log("cancelling bet " + wagerBytes32Id);
    return ContractStore.exec("CancelController", "cancelWagerCustom", [
        wagerBytes32Id, true
    ], {
            from: Web3Store.account
        });
}


// WEBPACK FOOTER //
// ./src/contract/CancelController.js